import { render, staticRenderFns } from "./uploadAnexo.vue?vue&type=template&id=7ff0b58c"
import script from "./uploadAnexo.ts?vue&type=script&lang=js&external"
export * from "./uploadAnexo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff0b58c')) {
      api.createRecord('7ff0b58c', component.options)
    } else {
      api.reload('7ff0b58c', component.options)
    }
    module.hot.accept("./uploadAnexo.vue?vue&type=template&id=7ff0b58c", function () {
      api.rerender('7ff0b58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/uploadAnexo/uploadAnexo.vue"
export default component.exports